<template>
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :title="title" :append-to-body="true"
    :default-cancel="false" :width="500" @close="closeDialog">
    <div>
      <ul class="form-list form-list-vertical">
        <li>
          <div class="form-label">
            <label>SecretId</label>
          </div>
          <div class="form-input">
            <div v-if="type==='create'" class="form-unit" :class="{'is-error': validateMsg.SecretId}">
              <input type="text" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.secret_id')"
                v-model.trim="form.SecretId">
              <p class="form-input-help" v-if="validateMsg.SecretId">{{validateMsg.SecretId}}</p>
            </div>
            <div v-else>
              <div class="form-unit">
                <p class="form-text">{{form.SecretId}}</p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div class="form-label">
            <label>SecretKey</label>
          </div>
          <div class="form-input">
            <div class="form-unit" :class="{'is-error': validateMsg.SecretKey}">
              <input type="password" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.secret_key')"
                v-model.trim="form.SecretKey">
              <p class="form-input-help" v-if="validateMsg.SecretKey">{{validateMsg.SecretKey}}</p>
            </div>
          </div>
        </li>

        <li>
          <div class="form-label">
            <label>{{$t('core.remark')}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit">
              <input type="text" class="tc-15-input-text full-width" :placeholder="$t('cos.placeholder.add_remark')"
                v-model.trim="form.Remark">
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="onConfirm" :title="$t('core.ok')">
            {{$t('core.ok')}}
          </qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.cancel')">
            {{$t('core.cancel')}}
          </qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import { getInnerProps } from '@/scripts/tools/utils';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    type: String, // edit | create
    credential: Object, // 当 type 为 edit 时必传
  },
  data() {
    return {
      form: {
        SecretId: '',
        SecretKey: '',
        Remark: '',
      },
      validateMsg: {
        SecretId: '',
        SecretKey: '',
      },
      advanceFormShow: false,
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    title() {
      if (this.type === 'edit') {
        return this.$t('cos.edit_session');
      }
      return this.$t('cos.create_session');
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.advanceFormShow = false;
        this.initData();
      }
    },
  },
  methods: {
    initData() {
      if (this.type === 'edit') {
        Object.keys(this.form).forEach(key => {
          this.form[key] = this.credential[key];
        });
      } else {
        this.form = {
          SecretId: '',
          SecretKey: '',
          Remark: '',
        };
        this.validateMsg = {
          SecretId: '',
          SecretKey: '',
        };
      }
    },
    validate() {
      this.validateMsg = {
        SecretId: '',
        SecretKey: '',
      };
      let allow = true;
      // 检查基本错误
      if (!this.form.SecretId) {
        allow = false;
        this.validateMsg.SecretId = this.$t('cos.validate.secret_id_empty');
      }
      if (!this.form.SecretKey) {
        allow = false;
        this.validateMsg.SecretKey = this.$t('cos.validate.secret_key_empty');
      }
      // if (this.SecretId.length !== 36) return errMsg =this.$t('cos.validate.secret_id_format');
      // if (!this.SecretId.startsWith('AKID')) return errMsg =this.$t('cos.validate.secret_key_must_start_with_AKID');
      // if (this.SecretKey.length !== 32) return errMsg =this.$t('cos.validate.secret_key_format');

      return allow;
    },
    onConfirm() {
      if (!this.validate()) return;
      this.$emit('submit', { form: this.form, type: this.type });
      this.closeDialog();
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>
